import './ReportingPage.scss'
import React from "react";
import {Alert, Button, CircularProgress, Grid} from "@mui/material";
import {ChevronLeft} from "@mui/icons-material";
import {useStores} from "../../stores";
import {observer} from "mobx-react-lite";
import {useLocation, useNavigate} from "react-router";
import {generateHomePath} from "../../routing/routing.utils";

export const ReportingPage: React.FC = observer(() => {
    const {
        rootAppStore,
        bagStore,
        categorizationReviewStore,
    } = useStores();
    const reviewPageFilterController = categorizationReviewStore.reviewPageController.reviewPageFilterController;
    const bagId = bagStore.bagId;
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <div>
            {/*A header with back button*/}
            <div className="categorization-page reporting-page">
                <Grid container alignItems="center" className="header">
                    <Grid className="text-center" size={2}>
                        <Button
                            color="primary"
                            variant="outlined"
                            startIcon={<ChevronLeft/>}
                            onClick={() => {
                                if (reviewPageFilterController.selectedLevel === 0) {
                                    navigate(generateHomePath(location, {id: String(bagId)}, rootAppStore.app));
                                } else {
                                    reviewPageFilterController.selectOneCategoryUp();
                                }
                            }}>
                            {reviewPageFilterController.selectedLevel === 0 ? 'To dashboard' : 'Back'}
                        </Button>
                    </Grid>

                    <Grid size={2}>
                        {categorizationReviewStore.categories.taxonomy_categories === null &&
                            <Grid container style={{marginTop: '2em'}}>
                                <Grid>
                                    <Alert severity="warning">Missing taxonomy</Alert>
                                </Grid>
                            </Grid>
                        }
                        {categorizationReviewStore.categories.taxonomy_categories === undefined &&
                            <Grid container style={{marginTop: '2em'}}>
                                <Grid>
                                    <Alert severity="info">
                                        Loading review, please wait
                                        <span className="ml-2 mr-1">
                                                <CircularProgress size={12}/>
                                            </span>
                                    </Alert>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </Grid>
                <div className="reporting-page-content">
                    TODO: CategorizationReport
                    {/*<CategorizationReport/>*/}
                </div>
            </div>

        </div>
    );
});
